export default "__VITE_ASSET__DsApTvrd__"